<template>
  <div class="paper-graph">
    <canvas ref="canvas" width="1800" height="300"></canvas>
  </div>
</template>

<script>
import paper, { Group, Path, Point } from 'paper'

export default {
  name: 'PaperGraph',
  data () {
    return {
      paper,
      graph: null,
      smooth: true,
      points: 13,
      pointsY: [30, 50, 230, 250, 230, 160, 180, 200, 230, 260, 230, 170, 250],
      group: []
    }
  },
  mounted () {
    this.graph = paper.setup(this.$refs.canvas)
    this.initGraph()
    this.graph.view.onFrame = this.onFrame
  },
  methods: {
    initGraph () {
      let view = this.graph.view
      let path1 = new Path()
      let path2 = new Path()
      let path3 = new Path()
      path1.fillColor = {
        gradient: {
          stops: ['#54EDFA', '#89EE90']
        },
        origin: view.bounds.bottomLeft,
        destination: view.bounds.bottomRight
      }

      path2.fillColor = 'rgb(220, 248, 252, .9)'
      path3.fillColor = 'rgb(220, 248, 252, .7)'

      path1.add(view.bounds.bottomLeft)
      path2.add(view.bounds.bottomLeft)
      path3.add(view.bounds.bottomLeft)
      for (let i = 0; i < this.points; i++) {
        let point1 = new Point(view.size.width / (this.points - 1) * i, this.pointsY[i])
        let point2 = new Point(view.size.width / (this.points - 1) * i + 60, this.pointsY[i] - 30)
        let point3 = new Point(view.size.width / (this.points - 1) * i - 150, this.pointsY[i] + 100)
        path1.add(point1)
        path2.add(point2)
        path3.add(point3)
      }
      path1.add(view.bounds.bottomRight)
      path2.add(view.bounds.bottomRight)
      path3.add(view.bounds.bottomRight)

      let group = new Group()
      group.children = [path3, path2, path1]
      this.group = group
    },
    onFrame (event) {
      for (let i = 0; i < this.points; i++) {
        let sinSeed1 = event.count + (i + i % 10) * 90
        let sinSeed2 = event.count + (i + i % 10) * 110
        let sinSeed3 = event.count + (i + i % 10) * 100
        let sinHeight1 = Math.sin(sinSeed1 / 200) * 20
        let sinHeight2 = Math.sin(sinSeed2 / 200) * 40
        let sinHeight3 = Math.sin(sinSeed3 / 200) * 30
        let yPos1 = Math.sin(sinSeed1 / 100) * sinHeight1 + this.pointsY[i]
        let yPos2 = Math.sin(sinSeed2 / 100) * sinHeight2 + this.pointsY[i] + 40
        let yPos3 = Math.sin(sinSeed3 / 100) * sinHeight3 + this.pointsY[i] + 20
        this.group.children[0].segments[i + 1].point.y = yPos1
        this.group.children[1].segments[i + 1].point.y = yPos2
        this.group.children[2].segments[i + 1].point.y = yPos3
      }
      this.group.children[0].smooth({ type: 'continuous' })
      this.group.children[1].smooth({ type: 'continuous' })
      this.group.children[2].smooth({ type: 'continuous' })
    },
  },
}
</script>

<style lang="scss" scoped>
canvas {
  width: 100%;
}
</style>
